import { createContext, useState, useReducer, useEffect } from 'react';
import Reducer from '../store/initialvalor';
import { InitValue } from '../store/initialvalor';
import api from '../utils/api';
import { takeToken } from '../utils/validateToken';
import useNav from '../hooks/useNav';

export type Rotina = {
  id: number,
  rotina: number,
  nomemenu: string
  funcao: number,
  ativo: boolean,
  nomerotina: string,
  menu: number,
  nomefuncao: string
}

export type RotinasUsuario = {
  rotinas: Rotina[],
  map: (rotina: unknown, index?: number) => any
}

export interface IAuth {
  children?: any
  auth?: boolean
  token?: string
  login?: string
  usuarioRotinas?: RotinasUsuario
  idUsuario?: number
  state?: any
  mudanca?: (e: any) => any
  setToken?: (e: any) => void
  setAuth?: (e: any) => void
  setLogin?: (e: any) => void
  setIdUsuario?: (e: any) => void
  setUsuarioRotinas?: (e: RotinasUsuario) => any
}


export const AuthContext = createContext<IAuth>({});

export default function AuthProvider(props: IAuth) {

  const [auth, setAuth] = useState<boolean>(false);
  const [token, setToken] = useState<string>(takeToken() || '');
  const [login, setLogin] = useState<string>('');
  const [idUsuario, setIdUsuario] = useState<number>(0);
  const [usuarioRotinas, setUsuarioRotinas] = useState<RotinasUsuario>([] as RotinasUsuario);
  const [state, mudanca] = useReducer(Reducer, InitValue);
  const { navTo } = useNav()

  useEffect(() => {
    if (token) {
      api.interceptors.request?.use(
        (req) => {
          req.headers.Authorization = `Bearer ${token}`;
          return req
        },
        error => error
      );
    };
    api.interceptors.response?.use(
      (req) => req,
      error => {
        if (error?.response?.status == 401) {
          localStorage?.clear();
          setAuth(false);
          navTo('/');
        }
        return error;
      }
    );
  }, [token])

  return (
    <AuthContext.Provider value={{
      auth,
      login,
      token,
      usuarioRotinas,
      setUsuarioRotinas,
      setIdUsuario,
      idUsuario,
      setToken,
      setAuth,
      setLogin,
      state,
      mudanca
    }}>
      {props.children}
    </AuthContext.Provider>
  )
}
